import { useState } from "react";
import { toast } from "sonner";
import api, { formatApiErrorDetail } from "@/lib/api";
import { useI18n } from "@/context/I18nContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Loader2 } from "lucide-react";

const EMPTY = { current: "", next: "", confirm: "" };

export const ChangePasswordDialog = ({ open, onClose }) => {
  const { t } = useI18n();
  const [f, setF] = useState(EMPTY);
  const [busy, setBusy] = useState(false);
  const close = () => { setF(EMPTY); onClose(); };
  const err = f.next && f.next.length < 8 ? t("8 caractères minimum")
    : f.confirm && f.confirm !== f.next ? t("Les deux mots de passe ne sont pas identiques") : "";
  const ok = f.current && f.next.length >= 8 && f.next === f.confirm;
  const submit = async (e) => {
    e.preventDefault();
    if (!ok) return;
    setBusy(true);
    try {
      await api.post("/auth/change-password", { current_password: f.current, new_password: f.next });
      toast.success(t("Mot de passe modifié"));
      close();
    } catch (ex) {
      toast.error(formatApiErrorDetail(ex.response?.data?.detail));
    } finally { setBusy(false); }
  };
  const field = (k, label, testid, auto) => (
    <div>
      <Label>{t(label)}</Label>
      <Input type="password" autoComplete={auto} value={f[k]} onChange={(e) => setF({ ...f, [k]: e.target.value })} className="mt-1.5" data-testid={testid} />
    </div>
  );
  return (
    <Dialog open={open} onOpenChange={(o) => !o && close()}>
      <DialogContent className="max-w-sm" data-testid="change-password-dialog">
        <DialogHeader>
          <DialogTitle>{t("Changer mon mot de passe")}</DialogTitle>
          <DialogDescription>{t("Vos autres appareils seront déconnectés.")}</DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-3">
          {field("current", "Mot de passe actuel", "change-password-current", "current-password")}
          {field("next", "Nouveau mot de passe", "change-password-new", "new-password")}
          {field("confirm", "Confirmer le nouveau mot de passe", "change-password-confirm", "new-password")}
          {err && <p className="text-xs text-destructive" data-testid="change-password-error">{err}</p>}
          <DialogFooter>
            <Button type="button" variant="ghost" onClick={close} data-testid="change-password-cancel">{t("Annuler")}</Button>
            <Button type="submit" disabled={!ok || busy} data-testid="change-password-submit">
              {busy && <Loader2 className="w-4 h-4 mr-2 animate-spin" />}{t("Enregistrer")}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
};
